export const DATE_RANGE = "date_range";
export const ENROLLMENTS_TYPE = "enrollment_data";
export const CLAIMS_TYPE = "claim_data";
export const ENROLLMENT_CLAIMS_TYPE = "enrollment_claims_data";
export const ORDERS_TYPE = "order_data";
export const COMPLETED_ORDERS_TYPE = "completed_order_data";
export const YEAR_TO_DATE = "year_to_date";
export const LAST_12_MONTH = "last_12_month";
export const LAST_30_DAYS = "last_30_days";
export const CURRENT_QUARTER = "current_quarter";
export const SORT_DIRECTIONS = ["ascend", "descend"];

export const DEFAULT_ENROLLMENT_DATE_TYPE_FILTER = "creation_date";
export const DEFAULT_CLAIM_DATE_TYPE_FILTER = "claim_date";
export const DEFAULT_ORDER_DATE_TYPE_FILTER = "order_date";

export const defaultFilters = {
  timeRangeFilter: { fromDate: null, toDate: null, value: YEAR_TO_DATE },
  enrollmentClaimsTimeRangeFilter: { fromDate: null, toDate: null, value: YEAR_TO_DATE },
  claimTimeRangeFilter: { fromDate: null, toDate: null, value: YEAR_TO_DATE },
  orderTimeRangeFilter: { fromDate: null, toDate: null, value: YEAR_TO_DATE },
  completedOrderTimeRangeFilter: { fromDate: null, toDate: null, value: YEAR_TO_DATE },
  enrollmentDateTypeFilter: DEFAULT_ENROLLMENT_DATE_TYPE_FILTER,
  claimDateTypeFilter: DEFAULT_CLAIM_DATE_TYPE_FILTER,
  orderDateTypeFilter: DEFAULT_ORDER_DATE_TYPE_FILTER,
  users: [],
  facilities: [],
  claimUsers: [],
  claimFacilities: [],
  enrollmentClaimsUsers: [],
  enrollmentClaimsFacilities: [],
  orderUsers: [],
  orderFacilities: [],
  completedOrderUsers: [],
  completedOrderFacilities: [],
  enrollmentType: true,
  enrollmentClaimsType: false,
  claimType: false,
  orderType: false,
  completedOrderType: false
};

export const defaultMultiples = {
  users: [],
  facilities: []
};

export const filterSort = (A, B, orderBy = "localSortKey") => {
  return A[orderBy].localeCompare(B[orderBy], "en", { sensitivity: "case", numeric: true });
};

export const dateFilterTypes = [
  { title: "Year to Date", value: YEAR_TO_DATE },
  { title: "Last 12 Months", value: LAST_12_MONTH },
  { title: "Last 30 Days", value: LAST_30_DAYS },
  { title: "Current Quarter", value: CURRENT_QUARTER }
];

export const enrollmentDateTypes = [
  { key: "1", value: "creation_date", translationText: "filters.creation_date_type" },
  { key: "2", value: "approved_date", translationText: "filters.approved_date_type" }
];

export const claimDateTypes = [
  { key: "1", value: "claim_date", translationText: "filters.claim_date_type" },
  { key: "2", value: "paid_date", translationText: "filters.paid_date_type" }
];

export const orderDateTypes = [
  { key: "1", value: "order_date", translationText: "filters.order_date_type" },
  { key: "2", value: "received_date", translationText: "filters.received_date_type" }
];

export const TABLE_FILTER_CONTAINER_ID = "table-filters-container";

export const ColumnsKeys = Object.freeze({
  reports: {
    enrollments: "enrollments",
    enrollment_claims: "enrollment_claims",
    claims: "claims",
    claim_line_items: "claim_line_items",
    orders: "orders",
    order_line_items: "order_line_items",
    completed_orders: "completed_orders",
    completed_order_line_items: "completed_order_line_items"
  }
});

export const SelectedReports = {
  enrollments: "enrollments",
  enrollment_claims: "enrollment_claims",
  claims: "claims",
  claim_line_items: "claim_line_items",
  orders: "orders",
  order_line_items: "order_line_items",
  completed_orders: "completed_orders",
  completed_order_line_items: "completed_order_line_items"
};
export const stringSort = (a, b, sortDirection = SORT_DIRECTIONS) => {
  return nullSort(a, b, sortDirection, () => {
    a = typeof a === "string" ? a.toLowerCase() : a.toString();
    b = typeof b === "string" ? b.toLowerCase() : b.toString();

    return a.localeCompare(b);
  });
};

// Handles sorting of values while properly managing null/undefined cases
// result of sortFunc() if neither value a nor b is null
export const nullSort = (a, b, sortDirection, sortFunc) => {
  if (!a && !b) return 0;
  else if (!a) return sortDirection === "ascend" ? 1 : -1;
  else if (!b) return sortDirection === "ascend" ? -1 : 1;
  return sortFunc();
};
